module.exports = __webpack_public_path__ + "static/media/bby_main@2x.15ef100d.jpg";